import { reactive } from 'vue'

const state = reactive({
  visible: false,
  message: '',
  color: 'error',
  timeout: 4000
})

let hideTimer = null
const queue = []

function normalizeMessage(message) {
  return String(message || '').trim()
}

function displaySnackbar(message, options = {}) {
  const text = normalizeMessage(message)
  if (!text) return

  const { color = 'error', timeout = 4000 } = options

  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }

  state.message = text
  state.color = color
  state.timeout = timeout
  state.visible = true

  if (timeout > 0) {
    hideTimer = setTimeout(() => {
      hideAppSnackbar()
    }, timeout)
  }
}

function drainQueue() {
  if (queue.length === 0 || state.visible) return
  const next = queue.shift()
  displaySnackbar(next.message, next.options)
}

export function getSnackbarState() {
  return state
}

export function hideAppSnackbar() {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  state.visible = false
  setTimeout(drainQueue, 200)
}

export function showAppSnackbar(message, options = {}) {
  const text = normalizeMessage(message)
  if (!text) return

  if (state.visible) {
    queue.push({ message: text, options })
    return
  }

  displaySnackbar(text, options)
}

export function showAppError(message, timeout = 5000) {
  showAppSnackbar(message, { color: 'error', timeout })
}

export function showAppSuccess(message, timeout = 4000) {
  showAppSnackbar(message, { color: 'success', timeout })
}

export function showAppWarning(message, timeout = 4500) {
  showAppSnackbar(message, { color: 'warning', timeout })
}

export function showAppInfo(message, timeout = 4000) {
  showAppSnackbar(message, { color: 'info', timeout })
}

/** User-facing text from Wall Labs API JSON (addWallpaper, listWallpapers, etc.). */
export function formatWallLabsApiMessage(data, fallback = 'Request completed.') {
  const msg = data?.Message || data?.message
  if (msg) return String(msg).trim()

  const status = data?.Status
  if (status) {
    return `API ${String(status).toUpperCase()}`
  }

  return fallback
}
